import { jsx } from 'react/jsx-runtime';
import { PureComponent } from 'react';
import classnames from 'classnames';
import '../../Icons/ArrowDown/index.js';
import '../../Icons/Camera/index.js';
import '../../Icons/Category/index.js';
import '../../Icons/CheckCircle/index.js';
import '../../Icons/Close/index.js';
import { ActiveFavorite, InactiveFavorite } from '../../Icons/Favorite/index.js';
import '../../Icons/Lens/index.js';
import '../../Icons/LensHeart/index.js';
import '../../Icons/Phone/index.js';
import '../../Icons/Pin/index.js';
import '../../Icons/Promo/index.js';
import '../../Icons/Share/index.js';
import '../../Icons/Bell/index.js';
import '../../Icons/Bin/index.js';
import '../../Icons/Check/index.js';
import '../../Icons/TriangleExclamation/index.js';
import '../../Icons/ShoppingBag/index.js';
import { Palette } from '../../lib/constants.js';
import classes from './index.module.scss.js';

const chooseColor = (status) => {
    if (status === 'active') {
        return Palette.RedCorporate;
    }
    else {
        return Palette.NeutralGrey2;
    }
};
const chooseIcon = (status) => {
    if (status === 'active') {
        return ActiveFavorite;
    }
    else {
        return InactiveFavorite;
    }
};
class ItemFavorite extends PureComponent {
    render() {
        const { status, className, onClick, ...others } = this.props;
        const FavoriteIcon = chooseIcon(status);
        const color = chooseColor(status);
        return (jsx("button", { type: "button", className: classnames(className, classes.container, classes[status]), onClick: onClick, "aria-label": "Preferito", "aria-pressed": status === 'active', ...others, children: jsx(FavoriteIcon, { fillColor: color }) }));
    }
}

export { ItemFavorite };
//# sourceMappingURL=index.js.map
